import { render, staticRenderFns } from "./r-patch-builder-dialog-v2.vue?vue&type=template&id=701816fd&scoped=true"
import script from "./r-patch-builder-dialog-v2.vue?vue&type=script&lang=js"
export * from "./r-patch-builder-dialog-v2.vue?vue&type=script&lang=js"
import style0 from "./r-patch-builder-dialog-v2.vue?vue&type=style&index=0&id=701816fd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701816fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701816fd')) {
      api.createRecord('701816fd', component.options)
    } else {
      api.reload('701816fd', component.options)
    }
    module.hot.accept("./r-patch-builder-dialog-v2.vue?vue&type=template&id=701816fd&scoped=true", function () {
      api.rerender('701816fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/patch/r-patch-builder-dialog-v2.vue"
export default component.exports